(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}


var $3vtib = parcelRequire("3vtib");
// This sets up the parse server 
const $8612e66024887d1b$var$STORAGE_ROOT = "fnsz_app_last_";
const $8612e66024887d1b$var$SERVER_URL = "https://funsizeapps.b4a.app/";
const $8612e66024887d1b$var$PEVENTS_ENDPOINT = "getPersonalEvents";
const $8612e66024887d1b$var$CEVENTS_ENDPOINT = "getCompanyEvents";
const $8612e66024887d1b$var$APP_ID = "rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9";
const $8612e66024887d1b$var$JAVASCRIPT_KEY = "xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv";
$3vtib.initialize($8612e66024887d1b$var$APP_ID, $8612e66024887d1b$var$JAVASCRIPT_KEY);
$3vtib.serverURL = $8612e66024887d1b$var$SERVER_URL;
var $8612e66024887d1b$var$funsizer;
window.addEventListener("load", ()=>{
    gsap.to(document.getElementsByClassName("loader-container")[0], {
        opacity: 1,
        duration: 0.25
    });
    gsap.to(document.getElementsByClassName("loader")[0], {
        scale: 0.5,
        duration: 1,
        ease: "bounce.out",
        repeat: -1,
        yoyo: true
    });
    document.getElementById("btn_logout").addEventListener("click", ()=>{
        $3vtib.User.logOut().then(()=>{
            $8612e66024887d1b$var$initFunsizer();
        });
    });
    $8612e66024887d1b$var$initFunsizer();
    const hiddens = document.querySelector("nav").getElementsByClassName("hidden");
    for(var i = 0; i < hiddens.length; i++)gsap.to(hiddens[i], {
        opacity: 1,
        duration: 0.35,
        delay: 0.2 * i
    });
});
const $8612e66024887d1b$var$initFunsizer = ()=>{
    $8612e66024887d1b$var$funsizer = $3vtib.User.current();
    if ($8612e66024887d1b$var$funsizer) $8612e66024887d1b$var$getIOTD().then((img)=>{
        gsap.to(document.getElementsByClassName("loader-container")[0], {
            opacity: 0,
            duration: 0.25
        });
        document.getElementById("iotd_title").innerHTML = img.Title;
        document.getElementById("iotd_subtitle").innerHTML = img.Description;
        document.getElementById("iotd_image").src = img.Image.url;
        const hiddens = document.getElementsByClassName("hidden");
        for(var i = 0; i < hiddens.length; i++)gsap.to(hiddens[i], {
            opacity: 1,
            duration: 0.35,
            delay: 0.2 * i
        });
    }).catch(function(e) {
        $8612e66024887d1b$var$handleParseError("Admin Error When Getting IOTD", e);
    });
    else window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
};
/**
  * IOTD Calls
  */ const $8612e66024887d1b$var$getIOTD = async ()=>{
    if (!$8612e66024887d1b$var$shouldLoadIOTDFromAPI()) {
        const iotd = localStorage.getObject(`${$8612e66024887d1b$var$STORAGE_ROOT}iotd_data`);
        return iotd;
    }
    try {
        const image = await $3vtib.Cloud.run("imageOfTheDay");
        const d = new Date();
        const day = d.getDay();
        localStorage.setObject(`${$8612e66024887d1b$var$STORAGE_ROOT}iotd_load`, day);
        localStorage.setObject(`${$8612e66024887d1b$var$STORAGE_ROOT}iotd_data`, image);
        return localStorage.getObject(`${$8612e66024887d1b$var$STORAGE_ROOT}iotd_data`);
    } catch (error) {
        throw error;
    }
};
const $8612e66024887d1b$var$shouldLoadIOTDFromAPI = ()=>{
    const data = localStorage.getObject(`${$8612e66024887d1b$var$STORAGE_ROOT}iotd_data`);
    const d = new Date();
    const day = d.getDay();
    const lastDay = localStorage.getObject(`${$8612e66024887d1b$var$STORAGE_ROOT}iotd_load`);
    if (lastDay == null || data == null) {
        localStorage.setObject(`${$8612e66024887d1b$var$STORAGE_ROOT}iotd_load`, day);
        return true;
    }
    return day != lastDay; // only refresh if a new day
};
function $8612e66024887d1b$var$handleParseError(msg, err) {
    switch(err.code){
        case $3vtib.Error.INVALID_SESSION_TOKEN:
            alert("Invalid session token.");
            $3vtib.User.logOut();
            window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
            break;
        default:
            console.log(`${msg} : ${err.code} - ${err.message}`);
    }
}
Storage.prototype.setObject = function(key, value) {
    this.setItem(key, JSON.stringify(value));
};
Storage.prototype.getObject = function(key) {
    var value = this.getItem(key);
    return value && JSON.parse(value);
};

})();
//# sourceMappingURL=index.beda832c.js.map
